import { render, staticRenderFns } from "./otherVisit.vue?vue&type=template&id=4928f713&"
import script from "./otherVisit.vue?vue&type=script&lang=js&"
export * from "./otherVisit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4928f713')) {
      api.createRecord('4928f713', component.options)
    } else {
      api.reload('4928f713', component.options)
    }
    module.hot.accept("./otherVisit.vue?vue&type=template&id=4928f713&", function () {
      api.rerender('4928f713', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/customerService/complaintManage/complaintQuery/otherVisit.vue"
export default component.exports